import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import Vue2Filters from 'vue2-filters'
import Paginate from 'vuejs-paginate'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import VTooltip from 'v-tooltip'
// import * as firebase from 'firebase'

// Default use
Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(Vue2Filters);
// Vue.use(VueMask);
Vue.use(VueTheMask);
Vue.use(VTooltip);
Vue.use(money);

Vue.component('paginate', Paginate);

Vue.config.ignoredElements = ['ion-icon']

// Config Firebase
// let config = {
//   apiKey: "AIzaSyAG7lihLqUVcbiP3NBwjqbBYhP-9yUpfgI",
//   authDomain: "marqmaster-1e5ab.firebaseapp.com",
//   databaseURL: "https://marqmaster-1e5ab.firebaseio.com",
//   projectId: "marqmaster-1e5ab",
//   storageBucket: "marqmaster-1e5ab.appspot.com",
//   messagingSenderId: "255180918847",
//   appId: "1:255180918847:web:935ea5f8918237fcc3688a"
// };
// firebase.initializeApp(config);
// let testing = firebase.storage().app.remoteConfig().fetchAndActivate();
// console.log('released', testing.getBoolean("released"));
// firebase.storage().app.remoteConfig().fetchAndActivate()
//   .then((resp) => {
//     console.log(resp, 'resp')
//   })
//   .catch((err) => {
//     console.error(err);
//   });
// Filters JS
import './filters.js';

// CSS
import 'vue-search-select/dist/VueSearchSelect.css';
import './assets/css/custom.css';


import Login from './vue/pages/public/login/Login.vue';
import Dashboard from './vue/pages/restricted/dashboard/dashboard.vue';
import Tickets from './vue/pages/restricted/funnel/tickets.vue';
import AllCompany from './vue/pages/restricted/allCompany/allCompany.vue';
import MarqTab from './vue/pages/restricted/allCompany/marqTabletCompany.vue';
import CompanyDetail from './vue/pages/restricted/companyDetail/companyDetail.vue';
import CompanyNotification from './vue/pages/restricted/companyDetail/companyNotification.vue';
import BroadcastList from './vue/pages/restricted/broadcast/broadcastList.vue';
import BroadcastCreate from './vue/pages/restricted/broadcast/broadcastCreate.vue';
import FeatureWindowList from './vue/pages/restricted/featureWindow/featureWindowList.vue';
import FeatureWindowCreate from './vue/pages/restricted/featureWindow/featureWindowCreate.vue';
import FeatureWindowEngagementPage from './vue/pages/restricted/featureWindow/featureWindowEngagementPage.vue';
import BroadcastEngagementPage from './vue/pages/restricted/broadcast/broadcastEngagementPage.vue';
import LisAllWorkShiftCyclic from './vue/pages/restricted/companyDetail/listAllWorkShiftCyclic.vue';
import ListWorkShiftDay from './vue/pages/restricted/companyDetail/listWorkShiftDay.vue';
import ListAllWorkShift from './vue/pages/restricted/companyDetail/listAllWorkShift.vue';
import ConfigurePhaseRules from './vue/pages/restricted/companyDetail/configurePhaseRules.vue';
import ConfigureCompanyPhaseRules from './vue/pages/restricted/companyDetail/configureCompanyPhaseRules.vue';
import ConfigureHE3 from './vue/pages/restricted/companyDetail/configureHE3.vue';
import ConfigureWorkshiftAdvanced from './vue/pages/restricted/companyDetail/configureWorkshiftAdvanced.vue';
import BalanceImport from './vue/pages/restricted/companyDetail/balanceImport.vue';
import ChanceDate from './vue/pages/restricted/companyDetail/chanceDate.vue';
import TotalAccess from './vue/pages/restricted/totalAccess/totalAccess.vue';
import Solicitation from './vue/pages/restricted/solicitation/solicitation.vue';
import Administrators from './vue/pages/restricted/administrators/administrators.vue';
import AllUser from './vue/pages/restricted/user/allUser/allUser.vue';
import UserLogin from './vue/pages/restricted/user/userLogin/userLoginDetail.vue';
import UserLastAccess from './vue/pages/restricted/user/lastAccess/lastAccess.vue';
import BlockDevice from './vue/pages/restricted/user/blockDevice/blockDevice.vue';
import AllUserDisabled from './vue/pages/restricted/companyDetail/allUserDisabled.vue';
import UserProfile from './vue/pages/restricted/user/userProfile/userProfile.vue';
import CodeSub from './vue/pages/restricted/codeSubscription/codeSubscription.vue';
import CreateCodeSub from './vue/pages/restricted/registerCodeSubscription/registerCodeSubscription.vue';
import ListPayment from './vue/pages/restricted/payment/listPayment/listPayment.vue';
import Excedentes from './vue/pages/restricted/payment/excedentes/excedentes.vue';
import ReconciliacaoExcedentes from './vue/pages/restricted/payment/reconciliacaoExcedentes/reconciliacaoExcedentes.vue';
import MigracaoAsaas from './vue/pages/restricted/payment/migracaoAsaas/migracaoAsaas.vue';
import MigracaoIuguAsaas from './vue/pages/restricted/payment/migracaoIuguAsaas/migracaoIuguAsaas.vue';
import PendingAndExpired from './vue/pages/restricted/payment/pendingAndExpired/pendingAndExpired.vue';
import DetailPayment from './vue/pages/restricted/payment/detailPayment/detailPayment.vue';
import LogPoint from './vue/pages/restricted/logPoint/logPoint.vue';
import LogStored from './vue/pages/restricted/logPoint/logStored.vue';
import LogInvoices from './vue/pages/restricted/logPoint/LogInvoices.vue';
import LogBalance from './vue/pages/restricted/logPoint/logBalance.vue';
import LogWorkingBalance from './vue/pages/restricted/logPoint/logWorkingBalance.vue';
import TagHistory from './vue/pages/restricted/logPoint/tagHistory.vue';
import Important from './vue/pages/restricted/important/important.vue';
import UPDIssues from './vue/pages/restricted/reports/UPDIssues.vue';
import ReportSale from './vue/pages/restricted/reports/reportSale';
import ReportBug from './vue/pages/restricted/reports/reportBug';
import ReportFull from './vue/pages/restricted/reports/reportFull';
import ReportCES from './vue/pages/restricted/reports/reportCES';
import ReportCSAT from './vue/pages/restricted/customerSuccess/reportCSAT';
import ExtraFeatures from './vue/pages/restricted/reports/extraFeatures';
import ReportSuggestion from './vue/pages/restricted/reports/reportSuggestion';
import AllNps from './vue/pages/restricted/nps/allNps.vue';
import AnalyzeNps from './vue/pages/restricted/nps/analyzeNps.vue';
import NewNps from './vue/pages/restricted/nps/newNps.vue';
import ListCancel from './vue/pages/restricted/allCompany/listCancel.vue';
import ListChurns from './vue/pages/restricted/allCompany/listChurns.vue';
import ListChurnsOld from './vue/pages/restricted/allCompany/listChurnsOld.vue';
import RegisterCompany from './vue/pages/restricted/allCompany/RegisterCompany.vue';
import PinList from './vue/pages/restricted/allCompany/pinList.vue';
import FollowUp from './vue/pages/restricted/allCompany/followUp.vue';
import RegisterFollowUp from './vue/pages/restricted/allCompany/RegisterFollowUp.vue';
import ListFunnel from './vue/pages/restricted/funnel/listFunnel.vue';
import ListTicket from './vue/pages/restricted/funnel/listTicket.vue';
import SupportTools from './vue/pages/restricted/support/supportTools.vue';
import DetailCompanyFunnel from './vue/pages/restricted/funnel/detailCompanyFunnel.vue';
import HealthScore from './vue/pages/restricted/healtScore/healthScore.vue';
import DetailHealthScore from './vue/pages/restricted/healtScore/detailHealthScore.vue';
import InvoiceHistory from './vue/pages/restricted/invoiceHistory/invoiceHistory.vue';
import ListSubscriptions from './vue/pages/restricted/invoiceHistory/listSubscriptions.vue';
import ListOnboarding from './vue/pages/restricted/onboarding/listOnboarding.vue';
import ListEvaluationOnboarding from './vue/pages/restricted/onboarding/listEvaluationOnboarding.vue';
import ListRenews from './vue/pages/restricted/payment/list-renews/listRenews';
import ListUpsell from './vue/pages/restricted/payment/list-upsell/listUpSell';
import BenefitsDock from "./vue/pages/restricted/benefits/benefits-dock";
import BenefitsPix from "./vue/pages/restricted/benefits/benefits-pix";
import BenefitsDashboard from "./vue/pages/restricted/benefits/benefits-dashboard";
import BenefitsRequests from "./vue/pages/restricted/benefits/benefits-requests";
import BenefitsKyc from "./vue/pages/restricted/benefits/benefits-kyc";
import BenefitsCardRequest from "./vue/pages/restricted/benefits/benefits-card-request";
import BenefitsPmaMovementExtract from "./vue/pages/restricted/benefits/benefits-pma-extract";
import store from './store'
import cancelDetail from "./vue/pages/restricted/allCompany/cancelDetail";
import ListBusinessUnits from './vue/pages/restricted/companyDetail/listBusinessUnits';
import DetailDaysUser from './vue/pages/restricted/user/detailDaysUser/detailDaysUser';
import detailsSolicitation from './vue/pages/restricted/benefits/cardsDetail/request-details';
import companySummary from './vue/pages/restricted/benefits/cardsDetail/company-summary';
import NewSale from "./vue/pages/restricted/sales/newSale.vue";
import ListCustomMirrorPoint from "./vue/pages/restricted/companyDetail/listCustomMirrorPoint.vue";
import NotasFiscais from "./vue/pages/restricted/payment/notasFiscais/NotasFiscais.vue";
import PaymentHealthcheck from "./vue/pages/restricted/healthcheck/paymentHealthcheck.vue";
import FaceLab from "./vue/pages/restricted/faceLab/faceLab.vue";
import FaceLabPoc from "./vue/pages/restricted/faceLab/faceLabPoc.vue";
import PiOverview from "./vue/pages/restricted/productIntelligence/piOverview.vue";
import PiEngagement from "./vue/pages/restricted/productIntelligence/piEngagement.vue";
import PiFeatures from "./vue/pages/restricted/productIntelligence/piFeatures.vue";
import PiFeatureDetail from "./vue/pages/restricted/productIntelligence/piFeatureDetail.vue";
import PiAreas from "./vue/pages/restricted/productIntelligence/piAreas.vue";
import PiAreaMetric from "./vue/pages/restricted/productIntelligence/piAreaMetric.vue";
import PiActivation from "./vue/pages/restricted/productIntelligence/piActivation.vue";
import PiRetention from "./vue/pages/restricted/productIntelligence/piRetention.vue";
import PiOperations from "./vue/pages/restricted/productIntelligence/piOperations.vue";
import PiCompanies from "./vue/pages/restricted/productIntelligence/piCompanies.vue";
import PiCompanyDetail from "./vue/pages/restricted/productIntelligence/piCompanyDetail.vue";
import PiOpportunities from "./vue/pages/restricted/productIntelligence/piOpportunities.vue";
import PiStatus from "./vue/pages/restricted/productIntelligence/piStatus.vue";
import PiAssistant from "./vue/pages/restricted/productIntelligence/piAssistant.vue";
import PiAssistantUsage from "./vue/pages/restricted/productIntelligence/piAssistantUsage.vue";
import PiUnlock from "./vue/pages/restricted/piUnlock/piUnlock.vue";
import { UNLOCK_PATH, browserStorage, needsUnlock } from "./vue/pages/components/pi/piUnlock.js";
import { blockedOutsideProduction } from "./vue/pages/components/pi/piAvailability.js";
import { PI_AVAILABLE } from "./urlConfig";


// Routes etc...
const routes = [
  {path: '/detalhes-da-empresa/:idCompany/:context', component: CompanyDetail, meta: {requiresAuth: true}},
  {path: '/login', component: Login, meta: {allowsLogin: true}},
  {path: '/dashboard', component: Dashboard, meta: {requiresAuth: true}},
  {path: '/tickets', component: Tickets, meta: {requiresAuth: true}},
  {path: '/tickets/:value/:id/:isActive', component: Tickets, meta: {requiresAuth: true}},
  {path: '/lista-de-empresas', component: AllCompany, meta: {requiresAuth: true}},
  {path: '/lista-de-empresas/:value/:type', component: AllCompany, meta: {requiresAuth: true}},
  {path: '/health-score', component: HealthScore, meta: {requiresAuth: true}},
  {path: '/detalhe-health-score/:companyId/:context', component: DetailHealthScore, meta: {requiresAuth: true}},
  {path: '/relatorio-de-vendas', component: ReportSale, meta: {requiresAuth: true}},
  {path: '/detalhes-cancelamentos', component: cancelDetail, meta: {requiresAuth: true}},
  {path: '/cancelamentos-old', component: ListCancel, meta: {requiresAuth: true}},
  {path: '/lista-de-churns', component: ListChurns, meta: {requiresAuth: true}},
  {path: '/lista-de-churns-old', component: ListChurnsOld, meta: {requiresAuth: true}},
  {path: '/cadastrar-empresa/:context', component: RegisterCompany, meta: {requiresAuth: true}},
  {path: '/lista-de-renovacao', component: ListRenews, meta: {requiresAuth: true}},
  {path: '/lista-de-upsell', component: ListUpsell, meta: {requiresAuth: true}},
  {path: '/nova-venda', component: NewSale, meta: {requiresAuth: true}},
  {path: '/nova-venda/:companyId/:context', component: NewSale, meta: {requiresAuth: true}},
  {path: '/followup', component: FollowUp, meta: {requiresAuth: true}},
  {path: '/funil', component: ListFunnel, meta: {requiresAuth: true}},
  {path: '/ferramentas', component: SupportTools, meta: {requiresAuth: true}},
  {path: '/lista-de-ticket/:ticketId', component: ListTicket, meta: {requiresAuth: true}},
  {path: '/empresa-detalhes-funil/:idPipe/:idBusiness', component: DetailCompanyFunnel, meta: {requiresAuth: true}},
  {path: '/cadastro-followup', component: RegisterFollowUp, meta: {requiresAuth: true}},
  {path: '/editar-followup/:idFup', component: RegisterFollowUp, meta: {requiresAuth: true}},
  {path: '/empresa-marqtab', component: MarqTab, meta: {requiresAuth: true}},
  {path: '/avisos-da-empresa/:idCompany/:context', component: CompanyNotification, meta: {requiresAuth: true}},
  // Avisos e Campanhas (cross-empresa). Nao confundir com /avisos-da-empresa,
  // que e o aviso de UMA empresa (db.Advice) e continua existindo.
  {path: '/avisos-e-campanhas', component: BroadcastList, meta: {requiresAuth: true}},
  {path: '/avisos-e-campanhas/novo', component: BroadcastCreate, meta: {requiresAuth: true}},
  // Liberacao temporaria de funcionalidade: aba irma das campanhas, debaixo do
  // mesmo caminho. Rota propria, e nao mais um tipo de aviso, porque o que ela
  // faz e ligar permissao — nao mostrar mensagem. Registrada ANTES de :id/editar
  // para nenhum segmento literal cair no parametro.
  {path: '/avisos-e-campanhas/liberacoes', component: FeatureWindowList, meta: {requiresAuth: true}},
  {path: '/avisos-e-campanhas/liberacoes/nova', component: FeatureWindowCreate, meta: {requiresAuth: true}},
  // Mesmo par das campanhas: a criacao em modo edicao e o engajamento em pagina propria.
  {path: '/avisos-e-campanhas/liberacoes/:id/editar', component: FeatureWindowCreate, meta: {requiresAuth: true}},
  {path: '/avisos-e-campanhas/liberacoes/:id/engajamento', component: FeatureWindowEngagementPage, meta: {requiresAuth: true}},
  // Mesmo componente da criacao: o :id liga o modo edicao e o passo final vira PUT.
  {path: '/avisos-e-campanhas/:id/editar', component: BroadcastCreate, meta: {requiresAuth: true}},
  // Pagina de engajamento por campanha (graficos e detalhe por empresa).
  {path: '/avisos-e-campanhas/:id/engajamento', component: BroadcastEngagementPage, meta: {requiresAuth: true}},
  {path: '/lista-turnos/:idCompany/:context', component: ListAllWorkShift, meta: {requiresAuth: true}},
  {path: '/regras-horas-extras/:idCompany/:context', component: ConfigurePhaseRules, meta: {requiresAuth: true}},
  {path: '/regras-horas-extras-empresa/:idCompany/:context', component: ConfigureCompanyPhaseRules, meta: {requiresAuth: true}},
  {path: '/configurar-he3/:idCompany/:context', component: ConfigureHE3, meta: {requiresAuth: true}},
  {path: '/config-avancada-turno/:idCompany/:context', component: ConfigureWorkshiftAdvanced, meta: {requiresAuth: true}},
  {path: '/importacao-saldo/:idCompany/:context', component: BalanceImport, meta: {requiresAuth: true}},
  {path: '/alterar-dados/:idCompany/:context', component: ChanceDate, meta: {requiresAuth: true}},
  {path: '/lista-turnos-ciclico/:idCompany/:context', component: LisAllWorkShiftCyclic, meta: {requiresAuth: true}},
  {
    path: '/lista-de-dias-do-turno/:idCompany/:idWs/:type/:context',
    component: ListWorkShiftDay,
    meta: {requiresAuth: true}
  },
  {path: '/total-de-acessos', component: TotalAccess, meta: {requiresAuth: true}},
  {path: '/aparelhos', component: BlockDevice, meta: {requiresAuth: true}},
  {path: '/solicitacoes', component: Solicitation, meta: {requiresAuth: true}},
  {path: '/lista-de-nps', component: AllNps, meta: {requiresAuth: true}},
  {path: '/analise-de-nps', component: AnalyzeNps, meta: {requiresAuth: true}},
  {path: '/novo-nps', component: NewNps, meta: {requiresAuth: true}},
  {path: '/cadastro-de-codigotradores', component: Administrators, meta: {requiresAuth: true}},
  {path: '/usuarios-ativos', component: AllUser, meta: {requiresAuth: true}},
  {path: '/usuarios-ativos/:value/:type', component: AllUser, meta: {requiresAuth: true}},
  {path: '/usuarios-login', component: UserLogin, meta: {requiresAuth: true}},
  {path: '/ultimos-acessos', component: UserLastAccess, meta: {requiresAuth: true}},
  {path: '/usuarios-desativados/:companyId', component: AllUserDisabled, meta: {requiresAuth: true}},
  {path: '/usuario', component: UserProfile, meta: {requiresAuth: true}},
  {path: '/usuario/:value/:type', component: UserProfile, meta: {requiresAuth: true}},
  {path: '/codigos-gerado', component: CodeSub, meta: {requiresAuth: true}},
  {path: '/cadastro-de-codigo', component: CreateCodeSub, meta: {requiresAuth: true}},
  {path: '/pendentes-expirados', component: PendingAndExpired, meta: {requiresAuth: true}},
  {path: '/lista-pagamentos', component: ListPayment, meta: {requiresAuth: true}},
  {path: '/excedentes', component: Excedentes, meta: {requiresAuth: true}},
  {path: '/reconciliacao-excedentes', component: ReconciliacaoExcedentes, meta: {requiresAuth: true}},
  {path: '/migracao-asaas', component: MigracaoAsaas, meta: {requiresAuth: true}},
  {path: '/migracao-iugu-asaas', component: MigracaoIuguAsaas, meta: {requiresAuth: true}},
  {path: '/detalhe-pagamento/:id/:subscriptionId', component: DetailPayment, meta: {requiresAuth: true}},
  {path: '/log-de-ponto', component: LogPoint, meta: {requiresAuth: true}},
  {path: '/log-armazenados', component: LogStored, meta: {requiresAuth: true}},
  {path: '/log-de-notas-fiscais', component: LogInvoices, meta: {requiresAuth: true}},
  {path: '/log-de-saldo/:userId/:contentSetting', component: LogWorkingBalance, meta: {requiresAuth: true}},
  {path: '/log-de-saldo-por-funcionario', component: LogBalance, meta: {requiresAuth: true}},
  {path: '/historico-de-tags', component: TagHistory, meta: {requiresAuth: true}},
  {path: '/lista-de-pins', component: PinList, meta: {requiresAuth: true}},
  {path: '/importantes', component: Important, meta: {requiresAuth: true}},
  {path: '/problemas-de-upd', component: UPDIssues, meta: {requiresAuth: true}},
  {path: '/relatorio-de-melhoria', component: ReportSuggestion, meta: {requiresAuth: true}},
  {path: '/relatorio-de-bugs', component: ReportBug, meta: {requiresAuth: true}},
  {path: '/relatorio-completo', component: ReportFull, meta: {requiresAuth: true}},
  {path: '/relatorio-csat', component: ReportCSAT, meta: {requiresAuth: true}},
  {path: '/relatorio-ces', component: ReportCES, meta: {requiresAuth: true}},
  {path: '/funcionalidades-extras', component: ExtraFeatures, meta: {requiresAuth: true}},
  {path: '/historico-de-faturas', component: InvoiceHistory, meta: {requiresAuth: true}},
  {path: '/historico-de-faturas/:companyId', component: InvoiceHistory, meta: {requiresAuth: true}},
  {path: '/notas-fiscais', component: NotasFiscais, meta: {requiresAuth: true}},
  {path: '/healthcheck-pagamentos', component: PaymentHealthcheck, meta: {requiresAuth: true}},
  {path: '/reconhecimento-facial', component: FaceLab, meta: {requiresAuth: true}},
  {path: '/reconhecimento-facial-poc', component: FaceLabPoc, meta: {requiresAuth: true}},
  {path: '/lista-de-assinaturas', component: ListSubscriptions, meta: {requiresAuth: true}},
  {path: '/lista-de-assinaturas/:companyId', component: ListSubscriptions, meta: {requiresAuth: true}},
  {path: '/lista-de-onboarding', component: ListOnboarding, meta: {requiresAuth: true}},
  {path: '/lista-avaliacao-de-onboarding', component: ListEvaluationOnboarding, meta: {requiresAuth: true}},
  {path: '/beneficios-dock', component: BenefitsDock, meta: {requiresAuth: true}},
  {path: '/pedido-beneficios-pix', component: BenefitsPix, meta: {requiresAuth: true}},
  {path: '/beneficios-dashboard', component: BenefitsDashboard, meta: {requiresAuth: true}},
  {path: '/beneficios-pedidos', component: BenefitsRequests, meta: {requiresAuth: true}},
  {path: '/beneficios-pedidos/:statusId', component: BenefitsRequests, meta: {requiresAuth: true}},
  {path: '/beneficios-kyc', component: BenefitsKyc, meta: {requiresAuth: true}},
  {path: '/beneficios-kyc/:statusId', component: BenefitsKyc, meta: {requiresAuth: true}},
  {path: '/solicitacao-cartao', component: BenefitsCardRequest, meta: {requiresAuth: true}},
  {path: '/solicitacao-cartao/:statusId', component: BenefitsCardRequest, meta: {requiresAuth: true}},
  {path: '/lista-unidades-negocio/:idCompany/:context', component: ListBusinessUnits, meta: {requiresAuth: true}},
  {path: '/detalhes-dia-usuario', component: DetailDaysUser, meta: {requiresAuth: true}},
  {path: '/extrato-movimentacao-pma', component: BenefitsPmaMovementExtract, meta: {requiresAuth: true}},
  {path: '/detalhes-solicitacao/:orderId', component: detailsSolicitation, meta: {requiresAuth: true}},
  {path: '/resumo-empresa', component: companySummary, meta: {requiresAuth: true}},
  {
    path: '/lista-de-espelhos-de-ponto-personalizados/:companyId/:context',
    component: ListCustomMirrorPoint,
    meta: {requiresAuth: true}
  },
  {path: '/product-intelligence/desbloquear', component: PiUnlock, meta: {requiresAuth: true}},
  {path: '/product-intelligence', component: PiOverview, meta: {requiresAuth: true}},
  {path: '/product-intelligence/engajamento', component: PiEngagement, meta: {requiresAuth: true}},
  {path: '/product-intelligence/funcionalidades', component: PiFeatures, meta: {requiresAuth: true}},
  {path: '/product-intelligence/funcionalidades/:featureType', component: PiFeatureDetail, meta: {requiresAuth: true}},
  {path: '/product-intelligence/areas', component: PiAreas, meta: {requiresAuth: true}},
  {path: '/product-intelligence/areas/metricas/:key', component: PiAreaMetric, meta: {requiresAuth: true}},
  {path: '/product-intelligence/ativacao', component: PiActivation, meta: {requiresAuth: true}},
  {path: '/product-intelligence/retencao', component: PiRetention, meta: {requiresAuth: true}},
  {path: '/product-intelligence/operacoes', component: PiOperations, meta: {requiresAuth: true}},
  {path: '/product-intelligence/empresas', component: PiCompanies, meta: {requiresAuth: true}},
  {path: '/product-intelligence/empresas/:companyId/:context', component: PiCompanyDetail, meta: {requiresAuth: true}},
  {path: '/product-intelligence/oportunidades', component: PiOpportunities, meta: {requiresAuth: true}},
  {path: '/product-intelligence/status', component: PiStatus, meta: {requiresAuth: true}},
  {path: '/product-intelligence/chat', component: PiAssistant, meta: {requiresAuth: true}},
  {path: '/product-intelligence/chat/consumo', component: PiAssistantUsage, meta: {requiresAuth: true}},
  {path: '/product-intelligence/pergunte', redirect: '/product-intelligence/chat'},
  {path: '/product-intelligence/pergunte/consumo', redirect: '/product-intelligence/chat/consumo'},
  // Blog

  // Otherwise redirect to home
  {path: '*', redirect: '/login'}
];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    let authUser = JSON.parse(window.localStorage.getItem('marQAdminAuthUser'));

    if (authUser && authUser.userToken && authUser.isAuth) {
      if (blockedOutsideProduction(to.path, PI_AVAILABLE)) {
        next({path: '/dashboard'});
        return;
      }
      if (needsUnlock(to.path, browserStorage(), Date.now())) {
        next({path: UNLOCK_PATH, query: {redirect: to.fullPath}});
        return;
      }
      next()
    } else {
      next({path: '/login'})
    }
  } else {
    if (to.meta.allowsLogin) {
      let authUser = JSON.parse(window.localStorage.getItem('marQAdminAuthUser'));
      if (authUser && authUser.userToken && authUser.isAuth) {
        next({path: '/dashboard'})
      } else {
        next()
      }
    }
  }
  next()
});

const app = new Vue({
  store,
  router
}).$mount('#app');





// WEBPACK FOOTER //
// ./src/main.js